import {WindowService} from '../../service/window/window.service';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {

  constructor(
    private _router: Router,
    private _windowServ: WindowService) {}

  ngOnInit() {
    this._windowServ.scrollTop();
  }

  public onSubmit(input: string) {
    if (input === 'star') {
      this._router.navigate(['/agreement']);
    } else {
      alert('コードが異なります');
    }
  }
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/pages/sign-in/sign-in.component.ts